import initBookingReward from '@ui/CustomerZone/BookingReward/component'
import SidePanel from '@ui/SidePanel/component'
import SnackbarManager from 'assets/core/js/module/snackbar-manager'
import type { SidePanelType } from '@ui/SidePanel/component'

export default function (): void {
  const snackbarEl = document.getElementById('booking-reward-snackbar')

  initBookingReward({
    onCopy: () => {
      if (snackbarEl) {
        SnackbarManager.initSnackbar(snackbarEl)
      }
    },
  })

  const trigger = document.querySelector<HTMLElement>('[data-booking-rewards-panel-open]')
  const sidePanelEl = document.getElementById('booking-rewards-side-panel')

  if (!trigger || !sidePanelEl) {
    return
  }

  let sidePanel: SidePanelType | undefined

  trigger.addEventListener('click', function () {
    if (!sidePanel) {
      sidePanel = SidePanel(sidePanelEl)
    }

    sidePanel.open()
  })
}
